/**
 * core/models/pages/home-page/ProfitPropositionsModel.js
*/
const advancedCardSlide = {
    slideImg: {
        src: 'profit-propositions/popular/advanced.webp',
        alt: 'Продвинутая карта',
    },
    slideTitle: {
        title: 'Продвинутая карта',
    },
    slideValue: {
        value: 'Надежность, удобство <br/>и&nbsp;максимальная выгода',
    },
    slideLink: '/for-individuals/cards/debet-cards/advanced',
};

/**
 * core/models/pages/home-page/ProfitPropositionsModel.js
*/
const mirSupremeCardSlide = {
    slideImg: {
        src: 'profit-propositions/popular/supreme.webp',
        alt: 'Mir Supreme',
    },
    slideTitle: {
        title: 'Mir Supreme<br/>до&nbsp;16% на&nbsp;остаток',
    },
    slideValue: {
        value: 'Кешбек&nbsp;5% на&nbsp;популярные категории',
    },
    slideLink: '/for-individuals/cards/debet-cards/mir-supreme',
};

/**
 * core/models/pages/home-page/ProfitPropositionsModel.js
*/
const fanCardSlide = {
    slideImg: {
        src: 'profit-propositions/promo/promo2.jpg',
        alt: 'Карта болельщика',
    },
    slideTitle: {
        title: 'Карта болельщика',
    },
    slideValue: {
        value: 'Будь еще ближе к&nbsp;любимым командам',
    },
    slideLink: '/for-individuals/cards/debet-cards?type=fans',
};

/**
 * core/models/pages/business-page/SelfemployedModel.js
*/
const selfemployedCardSlide = {
    slideImg: {
        src: 'pages/business/selfemployed/offer2.png',
        alt: 'Выгодная карта для самозанятых',
    },
    slideTitle: {
        title: 'Выгодная карта для самозанятых',
    },
    slideValue: {
        value: 'Выпуск и&nbsp;обслуживание&nbsp;&mdash; бесплатно',
    },
    slideLink: '/for-individuals/cards/debet-cards/selfemployed-card',
    slideAddition: {
        rate: '2,5',
        postfix: 'на остаток',
    },
};

/**
 * core/models/pages/business-page/SelfemployedModel.js
*/
const creditCardSlide = {
    slideImg: {
        src: 'pages/business/selfemployed/offer3.png',
        alt: 'Кредитные карты позволят осуществить Ваши повседневные желания',
    },
    slideTitle: {
        title: 'Кредитные карты',
    },
    slideValue: {
        value: 'Позволяют легко осуществлять Ваши повседневные желания или большие мечты',
    },
    slideLink: '/for-individuals/crediting/credit-cards',
};

/**
 * @/core/models/pages/esg/EsgModel.js
*/
const studentCardSlide = {
    slideImg: {
        src: 'pages/for-individuals/cards/student-card.jpg',
        alt: 'Школьникам и студентам',
    },
    slideTitle: {
        title: 'Школьникам и студентам',
    },
    slideLink: '/for-individuals/cards/student-cards',
};

/**
 * @/core/models/pages/esg/EsgModel.js
*/
const pensionCardSlide = {
    slideImg: {
        src: 'profit-propositions/popular/advanced.webp',
        alt: 'Для пенсионеров',
    },
    slideTitle: {
        title: 'Для пенсионеров',
    },
    slideValue: {
        value: 'Пенсионный вклад и Пенсионная карта',
    },
    slideLink: '/for-individuals/cards/debet-cards/pens',
};

/**
 * @/core/models/pages/esg/EsgModel.js
*/
const medicalProgectsSlide = {
    slideImg: {
        src: 'pages/social-projects/medical-professionals/medical-programms.jpg',
        alt: 'Социальным работникам',
    },
    slideTitle: {
        title: 'Социальным работникам',
    },
    slideValue: {
        value: 'Льготное кредитование для медработников',
    },
    slideLink: '/social-projects/medical-professionals',
};

/**
 * core/models/pages/home-page/ProfitPropositionsModel.js
*/
const childrenCardSlide = {
    slideImg: {
        src: 'profit-propositions/children/children-card.webp',
        alt: 'mir-child',
    },
    slideTitle: {
        title: 'Детская карта',
    },
    slideValue: {
        value: 'Удобство, выгода и&nbsp;безопасность &mdash;&nbsp;на&nbsp;5!',
    },
    slideLink: '/for-individuals/cards/debet-cards/mir-child',
};

export {
    advancedCardSlide,
    mirSupremeCardSlide,
    fanCardSlide,
    selfemployedCardSlide,
    creditCardSlide,
    studentCardSlide,
    pensionCardSlide,
    medicalProgectsSlide,
    childrenCardSlide,
};
